export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8081/api/v1';

export const ENDPOINTS = {
    PUBLIC: {
        GET_FEATURED_CONTEST: (slug, contestId) =>
            contestId
                ? `/public/organizations/${slug}/contests/featured?contestId=${contestId}`
                : `/public/organizations/${slug}/contests/featured`,
        STREAM: (id) => `/stream/contest/${id}`,
        REGISTER: (contestId) => `/public/contests/${contestId}/participants`,
        JOIN_PENALTY: (contestId) => `/public/contests/${contestId}/penalty-participants`,
        TRACK_EVENT: (contestId) => `/public/contests/${contestId}/track`,
        SUBSCRIBE_LEAD: '/public/leads/missed',
        AUTH_MAGIC_LOGIN: '/public/auth/magic-login',
        GET_ORGANIZATION: (slug) => `/public/organizations/${slug}`,
        CAMPAIGN_UNSUBSCRIBE: '/public/campaigns/unsubscribe',
        GET_REFERRAL: (code) => `/public/referral/${code}`,
    },
    PARTICIPANTS: {
        GET_LEADERBOARD: (contestId) => `/participant/contests/${contestId}/leaderboard`,
        GET_PENALTY_LEADERBOARD: (contestId) => `/participant/contests/${contestId}/penalty-leaderboard`,
        GET_ME: (contestId) => `/participant/contests/${contestId}/me`,
        SUBMIT_HALF_TIME: (contestId) => `/participant/contests/${contestId}/half-time-prediction`,
        SUBMIT_PENALTY: (contestId) => `/participant/contests/${contestId}/penalty-prediction`,
    },
    QUIZ: {
        GET_FOR_CONTEST: (contestId) => `/participant/contests/${contestId}/quiz`,
        PARTICIPATE: (contestId) => `/participant/contests/${contestId}/quiz/participate`,
    },
    PROFILING: {
        RECORD_ZONE: '/participant/profiling/zone',
    }
};

export const EVENT_TOPIC = {
    CONTEST_UPDATE: 'contest-update',
    PARTICIPANT_JOINED: 'participant-joined',
    HEARTBEAT: 'heartbeat'
};

export const buildUrl = (path) => `${API_BASE_URL}${path}`;